/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2025 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { pageTitleStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h3",
    as: "h1",
    css: css``,
};

pageTitleStyles.brandStyles = {
    logoImage: {
        css: css`
            img {
                max-width: 150px;
                max-height: 32px;
            }
            margin-bottom: 8px;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 4px;
        `,
    },
} as any;
pageTitleStyles.skeletonWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};
